// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3tbCf","item":"PaymentsMobile_item__iiiaI","label":"PaymentsMobile_label__hwrkY","amount":"PaymentsMobile_amount__21LG3"};